import NoOrgGuardContainer from './NoOrgGuardContainer';

export default NoOrgGuardContainer;
